import { connect } from 'react-redux';
import { Map, List } from 'immutable';

import decorate from 'src/utils/decorate';

import { CustomerTab } from './CustomerTab.tsx';

function mapStateToProps(state, props) {
    const customer = state.customers.get('list').get(parseInt(props.id, 10)) || Map();
    const bets = state.betslip.getIn(['bets', parseInt(props.id, 10)], List());
    const permissionGrants = state.user.getIn(['data', 'permissionGrants']);

    return {
        permissionGrants: permissionGrants,
        // name: customer.get('name'),
        //TODO: Remove after betslip refactor marge
        freeBetCredits: $appState.configState.precision.newFromAnything(
            state.customers.getIn(['freebetCredits', props.id, 'data', 'totalAmount'], 0)
        ).value,
        data: customer.get('data'),
        status: customer.get('state'),
        // errors: customer.get('errors'),
        bets,
        // audits: state.audits.get('items'),
        history: state.customers.get('history'),
        sports: state.sports.get('items') === undefined ? Map() : state.sports.get('items'),
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        // onSaveHistoryRequest: (id, data) => dispatch(saveHistory(id, data)),
        // onUpdateRequest: data => dispatch(update(props.id, data)),
        // onQueryAuditsRequest: (id, data, filterName) => {
        //     dispatch(queryAudit(id, data, filterName));
        // },
    };
}

// eslint-disable-next-line import/no-default-export
export default decorate(connect(mapStateToProps, mapDispatchToProps), CustomerTab);
